import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx-js-style";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { FaEdit, FaFileExport, FaFilter } from "react-icons/fa";
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";
import { GetJobCategoryLookupList, GetJobList } from "../../services/Job/JobApi";
import { Tooltip } from "@mui/material";
import Android12Switch from "../../components/common/AndroidSwitch";
import { MdOutlinePreview } from "react-icons/md";
import Select from "react-select";
import { CalenderFilterEnum, globalSelectStyles } from "../../middleware/enum";
import { GetClientLookupList, GetVendorLookupList } from "../../services/Client/ClientApi";
import { GetAllProjectLookupList, GetProjectLookupList } from "../../services/Project/projectApi";
import { GeStatusLookupList, GetAllUserLookupList } from "../../services/Staff/StaffApi";
import CalendarFilter from "../../components/common/CalenderFilter";
import dayjs from "dayjs";
import { CategoryLookupListAPI } from "../../services/Wallet/WalletApi";
import { GetExpenseReportList } from "../../services/Reports/ReportsApi";
import FilterDialog from "../../components/common/FilterDialog";
import FilterField from "../../components/common/FilterField";

export default function ExpenseReportListComponent() {
    //========================constant=======================
    const { userKeyID } = JSON.parse(localStorage.getItem("login"))
    const { setLoader } = useContext(LoaderContext);
    const { pageSize } = useContext(AuthContext);

    //========================state=======================
    const [valueSearch, setValueSearch] = useState(null)
    const [searchTimer, setSearchTimer] = useState(null)
    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fromDate, setFromDate] = useState(dayjs().startOf("week"));
    const [toDate, setToDate] = useState(dayjs().endOf("week"));
    const [totalExpenseCategory, setTotalExpenseCategory] = useState(0);
    const [lookupList, setLookupList] = useState({
        clientList: [],
        projectList: [],
        employeeList: [],
        jobCategoryList: [],
        statusList: [],
        expenseCategoryList: [],
        vendorRes: [],
    })
    const [listId, setListId] = useState({
        clientID: null,
        projectID: null,
        userID: null,
        expenseCategoryID: null,
        clientID: null,
    });
    const [appliedFilter, setAppliedFilter] = useState({
        userKeyID: userKeyID,
        pageNo: 0,
        pageSize: pageSize,
        sortingDirection: null,
        sortingColumnName: null,
        searchKeyword: null,
        fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
        toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
    })

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [tempFilter, setTempFilter] = useState({
        clientID: null,
        projectID: null,
        userID: null,
        expenseCategoryIDs: null,
        clientID: null,
        fromDate: null,
        toDate: null
    });

    // =================== Column Configs =====================

    const tableColumnsConfig = [
        { key: "vendorName", label: "Vendor/Client" },
        { key: "employeeName", label: "Employee" },
        { key: "projectAllocation", label: "Project" },
        { key: "category", label: "Category" },
        {
            key: "amount",
            label: (
                <div className="flex flex-col text-center">
                    <span>Amount</span>
                    <span className="text-[11px] font-bold text-green-600">
                        ₹ {Number(totalExpenseCategory).toLocaleString("en-IN")}
                    </span>
                </div>
            )
        },



        { key: "remark", label: "Remark" },
        { key: "expenseDate", label: "Expense Date" },
        // { key: "expenseImage", label: "Expense Image" },
    ];
    //========================useEffect======================= 
    useEffect(() => {
        const fetchLookupData = async () => {
            setLoader(true);
            try {
                const [
                    // clientRes,
                    // employeeRes,
                    // categoryRes,
                    // statusRes,
                    expenseCategoryRes,
                    projectRes,
                    vendorRes,
                ] = await Promise.all([
                    // GetClientLookupList(),
                    // GetAllUserLookupList(),
                    // GetJobCategoryLookupList(),
                    // GeStatusLookupList(),
                    CategoryLookupListAPI(),
                    GetAllProjectLookupList(),
                    GetVendorLookupList(),
                ]);

                setLookupList({
                    // clientList: mapToSelectOptions(
                    //     clientRes?.responseData?.data || [],
                    //     "clientName",
                    //     "clientID"
                    // ),

                    // employeeList: mapToSelectOptions(
                    //     employeeRes?.responseData?.data || [],
                    //     "name",
                    //     "userID"
                    // ),

                    // jobCategoryList: mapToSelectOptions(
                    //     categoryRes?.responseData?.data || [],
                    //     "categoryName",
                    //     "categoryID"
                    // ),

                    projectList: mapToSelectOptions(
                        projectRes?.responseData?.data || [],
                        "projectName",
                        "projectID"
                    ),   // add later if needed

                    // statusList: mapToSelectOptions(
                    //     statusRes?.responseData?.data || [],
                    //     "projectStatusName",
                    //     "projectStatusID"
                    // ),

                    expenseCategoryList: mapToSelectOptions(
                        expenseCategoryRes?.responseData?.data || [],
                        "expenseCategoryName",
                        "expenseCategoryID"
                    ),
                    vendorRes: mapToSelectOptions(
                        vendorRes?.responseData?.data || [],
                        "clientName",
                        "clientID"
                    )
                });
            } catch (error) {
                console.log("Lookup fetch error:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchLookupData();
    }, []);

    useEffect(() => {

        async function fetchData() {
            setLoader(true);
            const response = await GetExpenseReportList({
                ...appliedFilter,
            });
            setLoader(false);

            if (response?.statusCode == 200) {
                setTableRows(response.responseData.data);
                setTotalRecords(response?.totalRecords || response?.responseData?.data?.length || 0);
                // store totalExpenseCategory
                setTotalExpenseCategory(response.responseData.totalExpenseCategory || 0);
            } else {
                setTableRows([]);
                setTotalRecords(0);
                // store totalExpenseCategory
                setTotalExpenseCategory(0);
            }
        }
        if (appliedFilter?.fromDate && appliedFilter.toDate) fetchData();

    }, [appliedFilter]);

    //========================functions=======================
    const hasActiveFilters = () => {
        const {
            clientID,
            projectID,
            userID,
            expenseCategoryID,
            fromDate,
            toDate,
        } = appliedFilter;

        return Boolean(
            clientID ||
            projectID ||
            userID ||
            expenseCategoryID ||
            clientID ||
            fromDate ||
            toDate
        );
    };

    const mapToSelectOptions = (list = [], labelKey, valueKey) => {
        return list.map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    const getLabelByValue = (list = [], value) => {
        return list.find(item => item.value === value)?.label || "";
    };

    const handleJobExport = () => {
        const wb = XLSX.utils.book_new();
        const filterRows = [];
        if (appliedFilter.expenseCategoryID) {
            filterRows.push([
                "Category",
                getLabelByValue(lookupList.expenseCategoryList, appliedFilter.expenseCategoryID)
            ]);
        }
        if (appliedFilter.clientID) {
            filterRows.push([
                "Vendor",
                getLabelByValue(lookupList.vendorRes, appliedFilter.clientID)
            ]);
        }
        if (appliedFilter.projectID) {
            filterRows.push([
                "Project",
                getLabelByValue(lookupList.projectList, appliedFilter.projectID)
            ]);
        }
        if (appliedFilter.fromDate) {
            filterRows.push([
                "Start Date",
                appliedFilter.fromDate
            ]);
        }

        if (appliedFilter.toDate) {
            filterRows.push([
                "End Date",
                appliedFilter.toDate
            ]);
        }

        const titleText = "Title: Expense Report";
        const headers = [
            "Vendor/Client",
            "Employee",
            "Project",
            "Category",
            "Amount",
            "Remark",
            "Expense Date",
        ];

        const data = tableRows.map((row) => [
            row.vendorName || "-",
            row.employeeName || "-",
            row.projectAllocation || "-",
            row.category || "-",
            row.amount || "-",
            row.expenseDate ? new Date(row.expenseDate).toLocaleDateString() : "-",
            row.remark || "-",
        ]);

        const ws_data = [
            [titleText],
            [],
            ...(filterRows.length ? [["Applied Filters"]] : []),
            ...filterRows,
            ...(filterRows.length ? [[]] : []),
            [],
            headers,
            ...data
        ];
        const headerRowIndex =
            1 +                         // Title row
            1 +                         // Empty row
            (filterRows.length
                ? 1 + filterRows.length + 1 // "Applied Filters" + filters + empty
                : 0
            ) +
            1;



        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left", vertical: "left" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: headerRowIndex });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "D9E1F2" } }, // Light blue
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "medium", color: { rgb: "000000" } },
                        bottom: { style: "medium", color: { rgb: "000000" } },
                        left: { style: "medium", color: { rgb: "000000" } },
                        right: { style: "medium", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Data row styling
        const dataStartRow = headerRowIndex + 1;
        for (let r = dataStartRow; r < data.length + dataStartRow; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "center", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra styling for alternating rows
                    if ((r - dataStartRow) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F7F7F7" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Expenses Report");
        XLSX.writeFile(wb, "Expenses_Report.xlsx");
        setAppliedFilter({ ...appliedFilter, pageSize: pageSize })
    };

    const handleSearchFunction = (searchValue) => {
        setValueSearch(searchValue);

        // Clear old timer so API doesn't fire immediately
        if (searchTimer) clearTimeout(searchTimer);

        // Set new timer
        const timer = setTimeout(() => {
            setAppliedFilter({
                ...appliedFilter,
                searchKeyword: searchValue || null,
            });
        }, 500); // 500ms delay

        setSearchTimer(timer);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
    }

    //=====================render table=====================
    const renderTable = (columns = [], data = []) => {
        if (!columns.length) return null;

        return (
            <div className="flex flex-col table_wrapper border border-gray-200">
                <div className="flex-1 ">
                    <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                        <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                                {columns.map((col) => (
                                    <th
                                        key={col.key}
                                        className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-1"
                                    >
                                        {col.label}
                                    </th>
                                ))}

                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((client, index) => (
                                    <tr
                                        key={index}
                                        className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                    >
                                        {columns.map((col) => {
                                            let cellValue;


                                            if (col.key === "expenseDate" && client[col.key]) {
                                                cellValue = dayjs(client[col.key]).format("DD/MM/YYYY");
                                            } else {
                                                cellValue = client[col.key] || "-";
                                            }

                                            const isLongText = typeof cellValue === "string" && cellValue.length > 50;

                                            return (
                                                <td
                                                    key={col.key}
                                                    className="whitespace-nowrap px-2 py-2 text-xs leading-tight"
                                                >
                                                    {isLongText ? (
                                                        <Tooltip title={cellValue} arrow>
                                                            <span className="inline-block truncate max-w-[200px] cursor-pointer">
                                                                {cellValue}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        cellValue
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                    // <tr
                                    //     key={index}
                                    //     className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                    // >
                                    //     {columns.map((col) => (
                                    //         <td key={col.key} className="whitespace-nowrap px-2 py-1">
                                    //             {col.key === "expenseDate" && client[col.key]
                                    //                 ? dayjs(client[col.key]).format("DD/MM/YYYY") // only date
                                    //                 : client[col.key] || "-"}
                                    //         </td>
                                    //     ))}
                                    // </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length + 1}>
                                        <NoResultFoundModel totalRecords={totalRecords} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div >
            </div >
        );
    };

    return (
        <div>
            <>
                <div className="bg-gray-50 mx-auto rep-width">
                    <div className="h-full bg-white shadow rounded-lg flex flex-col">
                        {/* Header Section */}
                        <div className="p-2 border-b flex flex-col lg:flex-row gap-3 items-start">
                            <FilterDialog
                                maxWidth="md"
                                fullWidth
                                open={isFilterOpen}
                                title="Expense Filters"
                                onClose={() => setIsFilterOpen(false)}
                                onSubmit={() => {
                                    setCurrentPage(1);
                                    setAppliedFilter(prev => ({
                                        ...prev,
                                        ...tempFilter,
                                        pageNo: 0,
                                        searchKeyword: null
                                    }));
                                    setIsFilterOpen(false);
                                }}
                            >
                                {/* category starts  */}
                                <FilterField label="Category">
                                    <Select
                                        options={lookupList.expenseCategoryList}
                                        placeholder="Select Category"
                                        isClearable
                                        isMulti
                                        styles={globalSelectStyles}
                                        value={lookupList.expenseCategoryList.filter(
                                            opt => tempFilter.expenseCategoryIDs?.includes(opt.value)
                                        )}
                                        onChange={(options) =>
                                            setTempFilter(prev => ({
                                                ...prev,
                                                expenseCategoryIDs: options
                                                    ? options.map(o => o.value)
                                                    : []
                                            }))
                                        }
                                    />
                                </FilterField>
                                {/* <FilterField label="Category">
                                    <Select
                                        options={lookupList.expenseCategoryList}
                                        placeholder="Select Category"
                                        isClearable
                                        styles={globalSelectStyles}
                                        value={lookupList.expenseCategoryList.find(
                                            opt => opt.value === tempFilter.expenseCategoryID
                                        ) || null}
                                        onChange={(option) =>
                                            setTempFilter(prev => ({
                                                ...prev,
                                                expenseCategoryID: option?.value || null
                                            }))
                                        }
                                    />
                                </FilterField> */}

                                <FilterField label="Vendor">
                                    <Select
                                        options={lookupList.vendorRes}
                                        placeholder="Select Category"
                                        isClearable
                                        styles={globalSelectStyles}
                                        value={lookupList.vendorRes.find(
                                            opt => opt.value === tempFilter.clientID
                                        ) || null}
                                        onChange={(option) =>
                                            setTempFilter(prev => ({
                                                ...prev,
                                                clientID: option?.value || null
                                            }))
                                        }
                                    />
                                </FilterField>

                                <FilterField label="Project">
                                    <Select
                                        options={lookupList.projectList}
                                        placeholder="Select Project"
                                        isClearable
                                        styles={globalSelectStyles}
                                        value={lookupList.projectList.find(
                                            opt => opt.value === tempFilter.projectID
                                        ) || null}
                                        onChange={(option) =>
                                            setTempFilter(prev => ({
                                                ...prev,
                                                projectID: option?.value || null
                                            }))
                                        }
                                    />
                                </FilterField>

                                <FilterField label="Date">
                                    <CalendarFilter
                                        onDateChange={(fromDate, toDate) => {
                                            setFromDate(fromDate);
                                            setToDate(toDate);
                                            setCurrentPage(1);
                                            setTempFilter({
                                                ...tempFilter,
                                                fromDate: fromDate,
                                                toDate: toDate
                                            })
                                        }}
                                        toDate={toDate}
                                        setToDate={setToDate}
                                        fromDate={fromDate}
                                        setFromDate={setFromDate}
                                        hideAllOption={true} // Hide "All" option only here
                                        defaultSelectedOption={{
                                            value: CalenderFilterEnum.This_Month,
                                            label: "This Month",
                                        }} // Set default to "This Week"
                                    />
                                </FilterField>

                            </FilterDialog>



                            {/* Right-side: Export + Search */}
                            <div className="ml-auto flex items-center gap-2">

                                {/* Filter Button */}
                                <button
                                    onClick={() => {
                                        setIsFilterOpen(true);
                                        setTempFilter({ ...appliedFilter });
                                    }}
                                    className={`flex items-center gap-2 px-3 py-2 rounded border text-12 transition-all
                                    ${hasActiveFilters()
                                            ? "border-[#135EA0] text-[#135EA0] bg-blue-50"
                                            : "border-gray-300 text-gray-600 hover:border-[#135EA0]"
                                        }
                                `}
                                >
                                    <FaFilter
                                        size={12}
                                        className={hasActiveFilters() ? "text-[#135EA0]" : "text-gray-500"}
                                    />
                                    <span>Filter</span>
                                </button>

                                {/* {hasActiveFilters() && (
                                    <button
                                        type="button"
                                        className="flex items-center gap-2 px-3 py-2 rounded border border-red-300
                                               text-12 text-red-600 bg-red-50
                                               hover:border-red-400 hover:bg-red-100 transition-all"
                                        onClick={() => {
                                            setTempFilter({
                                                clientID: null,
                                                projectID: null,
                                                userID: null,
                                                expenseCategoryID: null,
                                                vendorID: null,
                                            });

                                            setAppliedFilter({
                                                ...appliedFilter,
                                                clientID: null,
                                                projectID: null,
                                                userID: null,
                                                expenseCategoryID: null,
                                                vendorID: null,
                                                pageNo: 0,
                                            });
                                        }}
                                    >
                                        Clear Filter
                                    </button>
                                )} */}

                                <button
                                    className="flex items-center gap-2 px-3 py-2 rounded border border-gray-300 text-12 text-gray-600 hover:border-[#135EA0] hover:text-[#135EA0]"
                                    onClick={() => {
                                        setAppliedFilter({
                                            ...appliedFilter,
                                            pageNo: 0,
                                            pageSize: 40
                                        });

                                        setTimeout(handleJobExport, 100);
                                    }}
                                >
                                    <FaFileExport size={12} />
                                    <span>Export</span>
                                </button>

                                {/* Search Input */}
                                <div className="relative w-[220px]">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-200 text-12 shadow appearance-none rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600"
                                        placeholder="Search..."
                                        value={valueSearch}
                                        onChange={(e) => handleSearchFunction(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="flex flex-col table_wrapper border border-gray-200">
                            <div className="flex-1 overflow-y-auto">
                                {renderTable(tableColumnsConfig, tableRows || [])}
                                {/* {totalRecords <= 0 && (
                                    <NoResultFoundModel totalRecords={totalRecords} />
                                )} */}
                            </div>

                            {/* Pagination */}
                            {totalRecords > pageSize && (
                                <div className="flex justify-end ">
                                    <PaginationComponent
                                        totalPages={Math.ceil(totalRecords / pageSize)}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        </div>
    )
}


// import React, { useContext, useEffect, useState } from "react";
// import * as XLSX from "xlsx-js-style";
// import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
// import { FaEdit, FaFileExport, FaFilter } from "react-icons/fa";
// import NoResultFoundModel from "../../components/common/NoDataFound";
// import PaginationComponent from "../../components/common/PaginationModal";
// import { GetJobCategoryLookupList, GetJobList } from "../../services/Job/JobApi";
// import { Tooltip } from "@mui/material";
// import Android12Switch from "../../components/common/AndroidSwitch";
// import { MdOutlinePreview } from "react-icons/md";
// import Select from "react-select";
// import { CalenderFilterEnum, globalSelectStyles } from "../../middleware/enum";
// import { GetClientLookupList, GetVendorLookupList } from "../../services/Client/ClientApi";
// import { GetAllProjectLookupList, GetProjectLookupList } from "../../services/Project/projectApi";
// import { GeStatusLookupList, GetAllUserLookupList } from "../../services/Staff/StaffApi";
// import CalendarFilter from "../../components/common/CalenderFilter";
// import dayjs from "dayjs";
// import { CategoryLookupListAPI } from "../../services/Wallet/WalletApi";
// import { GetExpenseReportList } from "../../services/Reports/ReportsApi";
// import FilterDialog from "../../components/common/FilterDialog";
// import FilterField from "../../components/common/FilterField";

// export default function ExpenseReportListComponent() {
//     //========================constant=======================
//     const { userKeyID } = JSON.parse(localStorage.getItem("login"))
//     const { setLoader } = useContext(LoaderContext);
//     const { pageSize } = useContext(AuthContext);

//     //========================state=======================
//     const [valueSearch, setValueSearch] = useState(null)
//     const [searchTimer, setSearchTimer] = useState(null)
//     const [tableRows, setTableRows] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [fromDate, setFromDate] = useState(dayjs().startOf("week"));
//     const [toDate, setToDate] = useState(dayjs().endOf("week"));
//     const [totalExpenseCategory, setTotalExpenseCategory] = useState(0);
//     const [lookupList, setLookupList] = useState({
//         clientList: [],
//         projectList: [],
//         employeeList: [],
//         jobCategoryList: [],
//         statusList: [],
//         expenseCategoryList: [],
//         vendorRes: [],
//     })
//     const [listId, setListId] = useState({
//         clientID: null,
//         projectID: null,
//         userID: null,
//         expenseCategoryID: null,
//         clientID: null,
//     });
//     const [appliedFilter, setAppliedFilter] = useState({
//         userKeyID: userKeyID,
//         pageNo: 0,
//         pageSize: pageSize,
//         sortingDirection: null,
//         sortingColumnName: null,
//         searchKeyword: null,
//         fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
//         toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
//     })

//     const [isFilterOpen, setIsFilterOpen] = useState(false);
//     const [tempFilter, setTempFilter] = useState({
//         clientID: null,
//         projectID: null,
//         userID: null,
//         expenseCategoryIDs: null,
//         clientID: null,
//         fromDate: null,
//         toDate: null
//     });

//     // =================== Column Configs =====================

//     const tableColumnsConfig = [
//         { key: "vendorName", label: "Vendor/Client" },
//         { key: "employeeName", label: "Employee" },
//         { key: "projectAllocation", label: "Project" },
//         { key: "category", label: "Category" },
//         {
//             key: "amount",
//             label: (
//                 <div className="flex flex-col text-center">
//                     <span>Amount</span>
//                     <span className="text-[11px] font-bold text-green-600">
//                         ₹ {Number(totalExpenseCategory).toLocaleString("en-IN")}
//                     </span>
//                 </div>
//             )
//         },



//         { key: "remark", label: "Remark" },
//         { key: "expenseDate", label: "Expense Date" },
//         { key: "expenseImage", label: "Expense Image" },
//     ];
//     //========================useEffect=======================
//     useEffect(() => {
//         const fetchLookupData = async () => {
//             setLoader(true);
//             try {
//                 const [
//                     // clientRes,
//                     // employeeRes,
//                     // categoryRes,
//                     // statusRes,
//                     expenseCategoryRes,
//                     projectRes,
//                     vendorRes,
//                 ] = await Promise.all([
//                     // GetClientLookupList(),
//                     // GetAllUserLookupList(),
//                     // GetJobCategoryLookupList(),
//                     // GeStatusLookupList(),
//                     CategoryLookupListAPI(),
//                     GetAllProjectLookupList(),
//                     GetVendorLookupList(),
//                 ]);

//                 setLookupList({
//                     // clientList: mapToSelectOptions(
//                     //     clientRes?.responseData?.data || [],
//                     //     "clientName",
//                     //     "clientID"
//                     // ),

//                     // employeeList: mapToSelectOptions(
//                     //     employeeRes?.responseData?.data || [],
//                     //     "name",
//                     //     "userID"
//                     // ),

//                     // jobCategoryList: mapToSelectOptions(
//                     //     categoryRes?.responseData?.data || [],
//                     //     "categoryName",
//                     //     "categoryID"
//                     // ),

//                     projectList: mapToSelectOptions(
//                         projectRes?.responseData?.data || [],
//                         "projectName",
//                         "projectID"
//                     ),   // add later if needed

//                     // statusList: mapToSelectOptions(
//                     //     statusRes?.responseData?.data || [],
//                     //     "projectStatusName",
//                     //     "projectStatusID"
//                     // ),

//                     expenseCategoryList: mapToSelectOptions(
//                         expenseCategoryRes?.responseData?.data || [],
//                         "expenseCategoryName",
//                         "expenseCategoryID"
//                     ),
//                     vendorRes: mapToSelectOptions(
//                         vendorRes?.responseData?.data || [],
//                         "clientName",
//                         "clientID"
//                     )
//                 });
//             } catch (error) {
//                 console.log("Lookup fetch error:", error);
//             } finally {
//                 setLoader(false);
//             }
//         };

//         fetchLookupData();
//     }, []);

//     useEffect(() => {

//         async function fetchData() {
//             setLoader(true);
//             const response = await GetExpenseReportList({
//                 ...appliedFilter,
//             });
//             setLoader(false);

//             if (response?.statusCode == 200) {
//                 setTableRows(response.responseData.data);
//                 setTotalRecords(response?.totalRecords || response?.responseData?.data?.length || 0);
//                 // store totalExpenseCategory
//                 setTotalExpenseCategory(response.responseData.totalExpenseCategory || 0);
//             } else {
//                 setTableRows([]);
//                 setTotalRecords(0);
//                 // store totalExpenseCategory
//                 setTotalExpenseCategory(0);
//             }
//         }
//         if (appliedFilter?.fromDate && appliedFilter.toDate) fetchData();

//     }, [appliedFilter]);

//     //========================functions=======================
//     const hasActiveFilters = () => {
//         const {
//             clientID,
//             projectID,
//             userID,
//             expenseCategoryID,
//             fromDate,
//             toDate,
//         } = appliedFilter;

//         return Boolean(
//             clientID ||
//             projectID ||
//             userID ||
//             expenseCategoryID ||
//             clientID ||
//             fromDate ||
//             toDate
//         );
//     };

//     const mapToSelectOptions = (list = [], labelKey, valueKey) => {
//         return list.map(item => ({
//             label: item[labelKey],
//             value: item[valueKey],
//         }));
//     };

//     const getLabelByValue = (list = [], value) => {
//         return list.find(item => item.value === value)?.label || "";
//     };

//     const handleJobExport = () => {
//         const wb = XLSX.utils.book_new();
//         const filterRows = [];
//         if (appliedFilter.expenseCategoryID) {
//             filterRows.push([
//                 "Category",
//                 getLabelByValue(lookupList.expenseCategoryList, appliedFilter.expenseCategoryID)
//             ]);
//         }
//         if (appliedFilter.clientID) {
//             filterRows.push([
//                 "Vendor",
//                 getLabelByValue(lookupList.vendorRes, appliedFilter.clientID)
//             ]);
//         }
//         if (appliedFilter.projectID) {
//             filterRows.push([
//                 "Project",
//                 getLabelByValue(lookupList.projectList, appliedFilter.projectID)
//             ]);
//         }
//         if (appliedFilter.fromDate) {
//             filterRows.push([
//                 "Start Date",
//                 appliedFilter.fromDate
//             ]);
//         }

//         if (appliedFilter.toDate) {
//             filterRows.push([
//                 "End Date",
//                 appliedFilter.toDate
//             ]);
//         }

//         const titleText = "Title: Expense Report";
//         const headers = [
//             "Vendor/Client",
//             "Employee",
//             "Project",
//             "Category",
//             "Amount",
//             "Remark",
//             "Expense Date",
//         ];

//         const data = tableRows.map((row) => [
//             row.vendorName || "-",
//             row.employeeName || "-",
//             row.projectAllocation || "-",
//             row.category || "-",
//             row.amount || "-",
//             row.expenseDate ? new Date(row.expenseDate).toLocaleDateString() : "-",
//             row.remark || "-",
//         ]);

//         const ws_data = [
//             [titleText],
//             [],
//             ...(filterRows.length ? [["Applied Filters"]] : []),
//             ...filterRows,
//             ...(filterRows.length ? [[]] : []),
//             [],
//             headers,
//             ...data
//         ];
//         const headerRowIndex =
//             1 +                         // Title row
//             1 +                         // Empty row
//             (filterRows.length
//                 ? 1 + filterRows.length + 1 // "Applied Filters" + filters + empty
//                 : 0
//             ) +
//             1;



//         const ws = XLSX.utils.aoa_to_sheet(ws_data);

//         // Merge title row
//         ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
//         ws["A1"].s = {
//             font: { bold: true, sz: 14 },
//             alignment: { horizontal: "left", vertical: "left" },
//         };

//         // Header row styling (row 2 / index 2)
//         headers.forEach((_, col) => {
//             const cellAddr = XLSX.utils.encode_cell({ c: col, r: headerRowIndex });
//             if (ws[cellAddr]) {
//                 ws[cellAddr].s = {
//                     font: { bold: true, color: { rgb: "000000" } },
//                     fill: { fgColor: { rgb: "D9E1F2" } }, // Light blue
//                     alignment: { horizontal: "center", vertical: "center" },
//                     border: {
//                         top: { style: "medium", color: { rgb: "000000" } },
//                         bottom: { style: "medium", color: { rgb: "000000" } },
//                         left: { style: "medium", color: { rgb: "000000" } },
//                         right: { style: "medium", color: { rgb: "000000" } },
//                     },
//                 };
//             }
//         });

//         // Data row styling
//         const dataStartRow = headerRowIndex + 1;
//         for (let r = dataStartRow; r < data.length + dataStartRow; r++) {
//             for (let c = 0; c < headers.length; c++) {
//                 const cellAddr = XLSX.utils.encode_cell({ c, r });
//                 if (ws[cellAddr]) {
//                     ws[cellAddr].s = {
//                         font: { color: { rgb: "000000" } },
//                         alignment: { horizontal: "center", vertical: "center" },
//                         border: {
//                             top: { style: "thin", color: { rgb: "000000" } },
//                             bottom: { style: "thin", color: { rgb: "000000" } },
//                             left: { style: "thin", color: { rgb: "000000" } },
//                             right: { style: "thin", color: { rgb: "000000" } },
//                         },
//                     };

//                     // Zebra styling for alternating rows
//                     if ((r - dataStartRow) % 2 === 1) {
//                         ws[cellAddr].s.fill = { fgColor: { rgb: "F7F7F7" } };
//                     }
//                 }
//             }
//         }

//         // Column widths for readability
//         ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

//         XLSX.utils.book_append_sheet(wb, ws, "Expenses Report");
//         XLSX.writeFile(wb, "Expenses_Report.xlsx");
//         setAppliedFilter({ ...appliedFilter, pageSize: pageSize })
//     };

//     const handleSearchFunction = (searchValue) => {
//         setValueSearch(searchValue);

//         // Clear old timer so API doesn't fire immediately
//         if (searchTimer) clearTimeout(searchTimer);

//         // Set new timer
//         const timer = setTimeout(() => {
//             setAppliedFilter({
//                 ...appliedFilter,
//                 searchKeyword: searchValue || null,
//             });
//         }, 500); // 500ms delay

//         setSearchTimer(timer);
//     };

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//         setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
//     }

//     //=====================render table=====================
//     const renderTable = (columns = [], data = []) => {
//         if (!columns.length) return null;

//         return (
//             <div className="flex flex-col table_wrapper border border-gray-200">
//                 <div className="flex-1 ">
//                     <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
//                         <thead>
//                             <tr className="z-1 sticky top-0 bg-white">
//                                 {columns.map((col) => (
//                                     <th
//                                         key={col.key}
//                                         className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-1"
//                                     >
//                                         {col.label}
//                                     </th>
//                                 ))}

//                             </tr>
//                         </thead>
//                         <tbody>
//                             {data.length > 0 ? (
//                                 data.map((client, index) => (
//                                     <tr
//                                         key={index}
//                                         className="hover:bg-slate-50 border-b border-slate-200 text-center"
//                                     >
//                                         {columns.map((col) => {
//                                             let cellValue;


//                                             if (col.key === "expenseDate" && client[col.key]) {
//                                                 cellValue = dayjs(client[col.key]).format("DD/MM/YYYY");
//                                             } else {
//                                                 cellValue = client[col.key] || "-";
//                                             }

//                                             const isLongText = typeof cellValue === "string" && cellValue.length > 50;

//                                             return (
//                                                 <td
//                                                     key={col.key}
//                                                     className="whitespace-nowrap px-2 py-2 text-xs leading-tight"
//                                                 >
//                                                     {isLongText ? (
//                                                         <Tooltip title={cellValue} arrow>
//                                                             <span className="inline-block truncate max-w-[200px] cursor-pointer">
//                                                                 {cellValue}
//                                                             </span>
//                                                         </Tooltip>
//                                                     ) : (
//                                                         cellValue
//                                                     )}
//                                                 </td>
//                                             );
//                                         })}
//                                     </tr>
//                                     // <tr
//                                     //     key={index}
//                                     //     className="hover:bg-slate-50 border-b border-slate-200 text-center"
//                                     // >
//                                     //     {columns.map((col) => (
//                                     //         <td key={col.key} className="whitespace-nowrap px-2 py-1">
//                                     //             {col.key === "expenseDate" && client[col.key]
//                                     //                 ? dayjs(client[col.key]).format("DD/MM/YYYY") // only date
//                                     //                 : client[col.key] || "-"}
//                                     //         </td>
//                                     //     ))}
//                                     // </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan={columns.length + 1}>
//                                         <NoResultFoundModel totalRecords={totalRecords} />
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div >
//             </div >
//         );
//     };

//     return (
//         <div>
//             <>
//                 <div className="bg-gray-50 mx-auto rep-width">
//                     <div className="h-full bg-white shadow rounded-lg flex flex-col">
//                         {/* Header Section */}
//                         <div className="p-2 border-b flex flex-col lg:flex-row gap-3 items-start">
//                             <FilterDialog
//                                 maxWidth="md"
//                                 fullWidth
//                                 open={isFilterOpen}
//                                 title="Expense Filters"
//                                 onClose={() => setIsFilterOpen(false)}
//                                 onSubmit={() => {
//                                     setCurrentPage(1);
//                                     setAppliedFilter(prev => ({
//                                         ...prev,
//                                         ...tempFilter,
//                                         pageNo: 0,
//                                         searchKeyword: null
//                                     }));
//                                     setIsFilterOpen(false);
//                                 }}
//                             >
//                                 {/* category starts  */}
//                                 <FilterField label="Category">
//                                     <Select
//                                         options={lookupList.expenseCategoryList}
//                                         placeholder="Select Category"
//                                         isClearable
//                                         isMulti
//                                         styles={globalSelectStyles}
//                                         value={lookupList.expenseCategoryList.filter(
//                                             opt => tempFilter.expenseCategoryIDs?.includes(opt.value)
//                                         )}
//                                         onChange={(options) =>
//                                             setTempFilter(prev => ({
//                                                 ...prev,
//                                                 expenseCategoryIDs: options
//                                                     ? options.map(o => o.value)
//                                                     : []
//                                             }))
//                                         }
//                                     />
//                                 </FilterField>
//                                 {/* <FilterField label="Category">
//                                     <Select
//                                         options={lookupList.expenseCategoryList}
//                                         placeholder="Select Category"
//                                         isClearable
//                                         styles={globalSelectStyles}
//                                         value={lookupList.expenseCategoryList.find(
//                                             opt => opt.value === tempFilter.expenseCategoryID
//                                         ) || null}
//                                         onChange={(option) =>
//                                             setTempFilter(prev => ({
//                                                 ...prev,
//                                                 expenseCategoryID: option?.value || null
//                                             }))
//                                         }
//                                     />
//                                 </FilterField> */}

//                                 <FilterField label="Vendor">
//                                     <Select
//                                         options={lookupList.vendorRes}
//                                         placeholder="Select Category"
//                                         isClearable
//                                         styles={globalSelectStyles}
//                                         value={lookupList.vendorRes.find(
//                                             opt => opt.value === tempFilter.clientID
//                                         ) || null}
//                                         onChange={(option) =>
//                                             setTempFilter(prev => ({
//                                                 ...prev,
//                                                 clientID: option?.value || null
//                                             }))
//                                         }
//                                     />
//                                 </FilterField>

//                                 <FilterField label="Project">
//                                     <Select
//                                         options={lookupList.projectList}
//                                         placeholder="Select Project"
//                                         isClearable
//                                         styles={globalSelectStyles}
//                                         value={lookupList.projectList.find(
//                                             opt => opt.value === tempFilter.projectID
//                                         ) || null}
//                                         onChange={(option) =>
//                                             setTempFilter(prev => ({
//                                                 ...prev,
//                                                 projectID: option?.value || null
//                                             }))
//                                         }
//                                     />
//                                 </FilterField>

//                                 <FilterField label="Date">
//                                     <CalendarFilter
//                                         onDateChange={(fromDate, toDate) => {
//                                             setFromDate(fromDate);
//                                             setToDate(toDate);
//                                             setCurrentPage(1);
//                                             setTempFilter({
//                                                 ...tempFilter,
//                                                 fromDate: fromDate,
//                                                 toDate: toDate
//                                             })
//                                         }}
//                                         toDate={toDate}
//                                         setToDate={setToDate}
//                                         fromDate={fromDate}
//                                         setFromDate={setFromDate}
//                                         hideAllOption={true} // Hide "All" option only here
//                                         defaultSelectedOption={{
//                                             value: CalenderFilterEnum.This_Month,
//                                             label: "This Month",
//                                         }} // Set default to "This Week"
//                                     />
//                                 </FilterField>

//                             </FilterDialog>



//                             {/* Right-side: Export + Search */}
//                             <div className="ml-auto flex items-center gap-2">

//                                 {/* Filter Button */}
//                                 <button
//                                     onClick={() => {
//                                         setIsFilterOpen(true);
//                                         setTempFilter({ ...appliedFilter });
//                                     }}
//                                     className={`flex items-center gap-2 px-3 py-2 rounded border text-12 transition-all
//                                     ${hasActiveFilters()
//                                             ? "border-[#135EA0] text-[#135EA0] bg-blue-50"
//                                             : "border-gray-300 text-gray-600 hover:border-[#135EA0]"
//                                         }
//                                 `}
//                                 >
//                                     <FaFilter
//                                         size={12}
//                                         className={hasActiveFilters() ? "text-[#135EA0]" : "text-gray-500"}
//                                     />
//                                     <span>Filter</span>
//                                 </button>

//                                 {/* {hasActiveFilters() && (
//                                     <button
//                                         type="button"
//                                         className="flex items-center gap-2 px-3 py-2 rounded border border-red-300
//                                                text-12 text-red-600 bg-red-50
//                                                hover:border-red-400 hover:bg-red-100 transition-all"
//                                         onClick={() => {
//                                             setTempFilter({
//                                                 clientID: null,
//                                                 projectID: null,
//                                                 userID: null,
//                                                 expenseCategoryID: null,
//                                                 vendorID: null,
//                                             });

//                                             setAppliedFilter({
//                                                 ...appliedFilter,
//                                                 clientID: null,
//                                                 projectID: null,
//                                                 userID: null,
//                                                 expenseCategoryID: null,
//                                                 vendorID: null,
//                                                 pageNo: 0,
//                                             });
//                                         }}
//                                     >
//                                         Clear Filter
//                                     </button>
//                                 )} */}

//                                 <button
//                                     className="flex items-center gap-2 px-3 py-2 rounded border border-gray-300 text-12 text-gray-600 hover:border-[#135EA0] hover:text-[#135EA0]"
//                                     onClick={() => {
//                                         setAppliedFilter({
//                                             ...appliedFilter,
//                                             pageNo: 0,
//                                             pageSize: 40
//                                         });

//                                         setTimeout(handleJobExport, 100);
//                                     }}
//                                 >
//                                     <FaFileExport size={12} />
//                                     <span>Export</span>
//                                 </button>

//                                 {/* Search Input */}
//                                 <div className="relative w-[220px]">
//                                     <input
//                                         type="text"
//                                         className="w-full border border-gray-200 text-12 shadow appearance-none rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600"
//                                         placeholder="Search..."
//                                         value={valueSearch}
//                                         onChange={(e) => handleSearchFunction(e.target.value)}
//                                     />
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Tab Content */}
//                         <div className="flex flex-col table_wrapper border border-gray-200">
//                             <div className="flex-1 overflow-y-auto">
//                                 {renderTable(tableColumnsConfig, tableRows || [])}
//                                 {/* {totalRecords <= 0 && (
//                                     <NoResultFoundModel totalRecords={totalRecords} />
//                                 )} */}
//                             </div>

//                             {/* Pagination */}
//                             {totalRecords > pageSize && (
//                                 <div className="flex justify-end ">
//                                     <PaginationComponent
//                                         totalPages={Math.ceil(totalRecords / pageSize)}
//                                         currentPage={currentPage}
//                                         onPageChange={handlePageChange}
//                                     />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </>
//         </div>
//     )
// }
